import { Button } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ChatAgentButtonBase } from '../../ChatAgent/components/ChatAgentButtonBase/ChatAgentButtonBase';
import { useIntercomMenu } from '../hooks/useIntercomMenu';
import styles from './HelpDropDown.module.scss';

export const HelpDropDown = ({ close }) => {
    const { toggle: toggleIntercom } = useIntercomMenu();

    const handleHelpClick = () => {
        toggleIntercom();
        if (close) {
            close();
        }
    };

    return (
        <div className={styles['container']}>
            <ChatAgentButtonBase
                id="HELP_CENTER"
                agentName="help_center"
                messageId="abby.help.center"
                className={styles['chat-agent-container']}
                buttonContentClassName={styles['chat-agent-button-content']}
                onClick={close}
                Icon={null}
            />
            <Button className={styles['button']} variant={Button.variant.text} onClick={handleHelpClick}>
                <FormattedMessage id="side.menu.intercom.help" defaultMessage="Chat with support" />
            </Button>
        </div>
    );
};
